import script from "./AssessmentGovernancePolicies.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentGovernancePolicies.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentGovernancePolicies.vue?vue&type=style&index=0&id=76483ccb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76483ccb"]])

export default __exports__